import React, { useEffect } from 'react';
import { withLoadingAndNoConnectionHandler } from '../integration-wrapper';
import { EarlySettlementFigureUi } from './ui';
import { useContracts } from '../contracts';
import { useVehicleImage } from '../contracts/vehicle-details-and-image/useVehicleImage';
import { VehicleImageView } from '@cp-shared-15/apis';
import { useFinancialDetails } from 'components/contracts/financial-details/useFinancialDetails';
import { useEarlySettlement } from './useEarlySettlement';

const EarlySettlementFigureWithHandlers = withLoadingAndNoConnectionHandler(EarlySettlementFigureUi);

export const EarlySettlementFigure: React.FC<{
    encryptedContractNumber?: string;
}> = ({ encryptedContractNumber }) => {
    const { data: contracts, isLoading: isContractsLoading, loadingError: contractsLoadingError } = useContracts();
    const contract = contracts?.find(c => c.encryptedContractNumber === encryptedContractNumber);

    const {
        data: financialDetails,
        isLoading: isFinancialDetailsLoading,
        loadingError: financialDetailsLoadingError,
    } = useFinancialDetails(contract?.contractNumber ?? '');
    const {
        data: vehicleImages,
        isLoading: isLoadingVehicleImage,
        loadingError: vehicleImageLoadingError,
    } = useVehicleImage(contract?.encryptedVin ?? '', VehicleImageView.EXTERIOR_FRONT_LEFT);

    const {
        data: earlySettlementData,
        isLoading: isEarlySettlementLoading,
        loadingError: earlySettlementLoadingError,
    } = useEarlySettlement(contract?.contractNumber ?? '');

    const isLoading =
        isContractsLoading || isFinancialDetailsLoading || isLoadingVehicleImage || isEarlySettlementLoading;
    const hasError = !!financialDetailsLoadingError || !!contractsLoadingError || !!earlySettlementLoadingError;

    useEffect(() => {
        setTimeout(() => {
            window.scrollTo(0, 0);
        }, 0);
    }, []);

    return (
        <EarlySettlementFigureWithHandlers
            contract={contract}
            financialDetails={financialDetails}
            vehicleImages={vehicleImages}
            earlySettlementData={earlySettlementData}
            showDefaultImage={!!vehicleImageLoadingError || (!isLoadingVehicleImage && !!vehicleImages?.images)}
            isLoading={isLoading}
            hasError={hasError}
        />
    );
};
